import React from 'react'

export const ImagesIcon = () => {
  return (
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.796 22.75h15.166c1.197 0 2.167-.97 2.167-2.167V5.417c0-1.197-.97-2.167-2.167-2.167H5.796c-1.197 0-2.167.97-2.167 2.167v15.166c0 1.197.97 2.167 2.167 2.167zm0 0 11.916-11.917 5.417 5.417M11.212 9.208a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0z" stroke="#101828" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}
